import {Component, OnInit, ViewChild} from '@angular/core';
import {RegisteredUsersApiService} from '../../services/api/users/registered-users/registered-users-api.service';
import {DisplayedColumnInf} from '../../interfaces/common/table/displayed-column-inf';
import {ServerPageRequest} from '../../classes/common/table/server-page-request';
import {TableColumnsConfigurationDialogComponent} from '../../dialogs/table-columns-configuration-dialog/table-columns-configuration-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {PageEvent} from '@angular/material/paginator';
import {SearchTermDefinitionInf} from '../../interfaces/common/search/search-term-definition-inf';
import Search from '../../utils/search';
import {RegisteredUsersSearchComponent} from './registered-users-search/registered-users-search.component';
import {ArmTableComponent} from '../../components/arm-table/arm-table.component';
import {LoaderService} from '../../services/common/loader-service/loader.service';
import {UsersExportDialogComponent} from "../users-tab/users-export-dialog/users-export-dialog.component";
import {AcDialogService} from "ac-infra";

@Component({
  selector: 'registered-users',
  templateUrl: './registered-users.component.html',
  styleUrls: ['./registered-users.component.scss']
})
export class RegisteredUsersComponent implements OnInit {

  data: any = {users: [], totalElements: 0};
  nodes;
  pCons;

  @ViewChild(ArmTableComponent) armTable;

  serverPageRequest: ServerPageRequest = new ServerPageRequest({
    pageIndex: 0,
    pageSize: 25,
    length: 0
  });

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'user', display: 'User', selected: true, width: 200},
    {name: 'host', display: 'Host', selected: true, width: 200},
    {name: 'nodeName', display: 'Node', selected: true, width: 200},
    {name: 'pconsNames', display: 'Peer Connections', selected: true, width: 200},
  ];

  search: any = {};
  searchData: any = {};
  searchTerms: SearchTermDefinitionInf[] ;

  registeredUsersSearchComponent = RegisteredUsersSearchComponent;

  constructor(private registeredUsersApiService: RegisteredUsersApiService,
              public dialog: MatDialog,
              private loaderService: LoaderService,
              private acDialogService: AcDialogService) { }

  ngOnInit(): void {
    this.init();
  }

  refresh(): void {
    const params = {...this.search, ...this.serverPageRequest};
    this.loaderService.showMainContainer();
    this.registeredUsersApiService.getRegisteredUsers(params).then((data) => {
      this.data = data;
      this.addNodesAndPConsNames(data.users, this.nodes, this.pCons);
      this.loaderService.hideMainContainer();
    }).catch((error) => {
      console.log(`Exception was thrown in refresh registered users, reason: ${error}`);
      this.loaderService.hideMainContainer();
    });
  }

  addNodesAndPConsNames(registeredUsers, nodes, pCons): void {
    registeredUsers.forEach(registeredUser => {
      const find = nodes.find(node => node.id === registeredUser.nodeId);
      registeredUser.nodeName = find !== undefined ? find.name : 'Unknown node';
      registeredUser.pconsNames = pCons.filter(pCon => registeredUser.pConIds.indexOf(pCon.id) !== -1).map(pCon => pCon.name);
    });
  }

  openColumnsConfiguration(): void {
    const dialogRef = this.dialog.open(TableColumnsConfigurationDialogComponent, {
      width: '350px',
      data: {
        columns: this.displayedColumns
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      dialogRef.close();
    });
  }

  exportToCSV(): void {
    const parameters = this.search;

    const dialogData = {enclose : false};
    this.acDialogService.open(UsersExportDialogComponent, {
      dialogData,
      title: 'Export Registered Users',
      onSubmit: () => {
        parameters.enclose = dialogData.enclose;
        this.registeredUsersApiService.exportUsersToCsv(parameters);
      }
    });
  }


  pageChanged(pageInfo: PageEvent): void {
    this.serverPageRequest = new ServerPageRequest(pageInfo);
    this.refresh();
  }

  private setSearchOptions(): void {
    this.searchData = {
      data: {},
      nodesOptions: Search.generateSearchOptions(this.nodes, 'name', 'id'),
      pConsOptions: Search.generateSearchGroupOptions(this.pCons, 'name', 'id', 'nodeName')
    };

    this.searchTerms = [
      {term: 'user', operator: ':', displayName: 'User'},
      {term: 'host', operator: ':', displayName: 'Host'},
      {term: 'nodeId', operator: '=', displayName: 'Node',displayValue: Search.getOptionValue(this.searchData.nodesOptions)},
      {term: 'pConId', operator: '=', displayName: 'Peer Connection',displayValue: Search.getOptionValue(this.searchData.pConsOptions)}
    ];
  }

  private init(): void {
    this.registeredUsersApiService.getExternalData().then(data => {
      this.nodes = data[0];
      this.pCons = data[1];
      this.refresh();
      this.setSearchOptions();
    });
  }

  onSearch(data: any): void {
    this.armTable.firstPage();
    this.serverPageRequest.firstPage();
    this.search = data;
    this.refresh();
  }
}
